export default "/assets/full-width-0bb7c09b7852d82bca75e6d01de45bc4c4172982d434a7a14db42f76e0d4629d.svg";